import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import FarmTransitionSystem from 'System/FarmTransitionSystem';
import BaseUISystem from 'System/UI/BaseUISystem';
import DataConflictsMenuHandler from 'System/UI/Menu/DataConflictsMenuHandler';
import GBCDisconnectedMenuHandler from 'System/UI/Menu/GBCDisconnectedMenuHandler';

export default class FarmTransitionScene extends Scene {
    public init(): void {
        this.addSystem(new FarmTransitionSystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        const UISystem = new BaseUISystem(Game.store);
        UISystem.handlers = [new GBCDisconnectedMenuHandler(UISystem), new DataConflictsMenuHandler(UISystem)];
        this.addSystem(UISystem);

        this.systems.forEach(system => system.init());
    }

    public async preload() {
        addDragonbonesResources('my_farm_loading', `${DRAGONBONES_PATH}/MyFarmLoading/`);

        Game.resource.add('my_farm_bg', 'resource/graphics/other/my_farm_bg.jpg');

        return Game.resource.load();
    }
}
